import React, { useMemo } from 'react';
import styles from './UIGamePlayerOptionsDropdown.module.scss';
import { TradeEmbargoControllerReader } from '@colonist/game-base-types';
import IconGiftBoxDark from '@static/images/icon_gift_box_dark.svg';
import { Dropdown, T } from '@colonist/ui';
import { useGameStore } from '../../store/GameStoreContext.ts';
import { useIsReplay } from '../../store/selectors/useIsReplay.ts';
export const UIGamePlayerOptionsDropdown = ({ playerValidator, children, className, excludeOptions = [], shouldOpenSendGiftPageInternally = false })=>{
    const myColor = useGameStore((state)=>state.myColor);
    const isReplay = useIsReplay();
    const tradeState = useGameStore((state)=>state.gameState.tradeState);
    const mutedPlayers = useGameStore((state)=>state.gameMute.mutedPlayers);
    const toggleMuteForPlayer = useGameStore((state)=>state.gameMute.toggleMuteForPlayer);
    const onClickToggleEmbargoAgainstPlayer = useGameStore((state)=>state.gameTrade.onClickToggleEmbargoAgainstPlayer);
    const isMyColorSpectator = useGameStore((state)=>state.isMyColorSpectator);
    const sendGiftMembershipClickAnalytics = useGameStore((state)=>state.gameAnalytics.sendGiftMembershipClickAnalytics);
    const shouldHideAllSendGiftOption = useGameStore((state)=>state.gameClientConfig.shouldHideAllSendGiftOption);
    const canSendGiftAfterGameEnd = useGameStore((state)=>state.gameClientConfig.canSendGiftAfterGameEnd);
    const hideMuteUserOption = useGameStore((state)=>state.gameClientConfig.hideMuteUserOption);
    const onClickSendGift = useGameStore((state)=>state.gameClientConfig.onClickSendGift);
    const onClickAddFriend = useGameStore((state)=>state.gameClientConfig.onClickAddFriend);
    const onClickViewProfile = useGameStore((state)=>state.gameClientConfig.onClickViewProfile);
    const onClickReportPlayer = useGameStore((state)=>state.gameClientConfig.onClickReportPlayer);
    const isPlayerMuted = mutedPlayers.includes(playerValidator.username);
    const friendUsernames = useGameStore((state)=>state.gameClientConfig.friendUsernames);
    const isFriend = friendUsernames.includes(playerValidator.username);
    const isTradeBlocked = useMemo(()=>TradeEmbargoControllerReader.doesPlayer1HaveAnEmbargoAgainstPlayer2(tradeState.embargoState, myColor, playerValidator.color), [
        tradeState,
        myColor,
        playerValidator.color
    ]);
    const isCurrentUser = playerValidator.isCurrentUser;
    const isPlayerMyPerspective = playerValidator.color === myColor;
    const sendGiftOption = {
        label: /*#__PURE__*/ React.createElement("div", {
            className: styles.sendGift
        }, /*#__PURE__*/ React.createElement("img", {
            src: IconGiftBoxDark
        }), " ", /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:storePage.sendGift'
            }
        })),
        onClick: ()=>{
            sendGiftMembershipClickAnalytics();
            onClickSendGift(playerValidator.username, shouldOpenSendGiftPageInternally);
        },
        hidden: excludeOptions.includes('sendGift') || shouldHideAllSendGiftOption || !canSendGiftAfterGameEnd && !shouldOpenSendGiftPageInternally || !playerValidator.isUser || isCurrentUser || playerValidator.isLocalDiscordPlayer
    };
    const addFriendOption = {
        label: /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:game.playerOptionsPopup.addFriend'
            }
        }),
        onClick: ()=>{
            onClickAddFriend(playerValidator.username);
        },
        hidden: excludeOptions.includes('addFriend') || playerValidator.isLocalDiscordPlayer || !playerValidator.isUser || isCurrentUser || isFriend
    };
    const viewProfileOption = {
        label: /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:game.playerOptionsPopup.viewProfile'
            }
        }),
        onClick: ()=>{
            onClickViewProfile(playerValidator.username);
        },
        hidden: excludeOptions.includes('viewProfile') || playerValidator.isLocalDiscordPlayer || !playerValidator.isUser
    };
    const blockTradesOption = {
        label: /*#__PURE__*/ React.createElement(T, {
            id: {
                key: isTradeBlocked ? 'strings:game.playerOptionsPopup.unblockTrades' : 'strings:game.playerOptionsPopup.blockTrades'
            }
        }),
        onClick: ()=>{
            onClickToggleEmbargoAgainstPlayer(playerValidator.color);
        },
        hidden: excludeOptions.includes('blockTrades') || isReplay || isPlayerMyPerspective || isCurrentUser || isMyColorSpectator
    };
    const muteOption = {
        label: /*#__PURE__*/ React.createElement(T, {
            id: {
                key: isPlayerMuted ? 'strings:game.playerOptionsPopup.unmute' : 'strings:game.playerOptionsPopup.mute'
            }
        }),
        onClick: ()=>{
            toggleMuteForPlayer(playerValidator.username);
        },
        hidden: excludeOptions.includes('mute') || isReplay || playerValidator.isLocalDiscordPlayer || isPlayerMyPerspective || hideMuteUserOption || !playerValidator.isUser || isCurrentUser || isMyColorSpectator
    };
    const reportOption = {
        label: /*#__PURE__*/ React.createElement("div", {
            className: styles.report
        }, /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:game.playerOptionsPopup.report'
            }
        })),
        onClick: ()=>{
            onClickReportPlayer(playerValidator.username, playerValidator.color);
        },
        hidden: excludeOptions.includes('report') || playerValidator.isLocalDiscordPlayer || !playerValidator.isUser || isCurrentUser
    };
    const options = [
        viewProfileOption,
        addFriendOption,
        sendGiftOption,
        blockTradesOption,
        muteOption,
        reportOption
    ];
    const isEmptyOption = useMemo(()=>options.every((option)=>option.hidden), [
        options
    ]);
    if (isEmptyOption) {
        /*#__PURE__*/ React.createElement("div", {
            className: className
        }, children);
    }
    return /*#__PURE__*/ React.createElement(Dropdown, {
        className: className,
        options: options
    }, children);
};
